import React from 'react';
import { motion } from 'framer-motion';

function NumberGrid({ numbers, drawId }) {
  return (
    <div className="number-grid" aria-label="Numere generate">
      {numbers.map((number, index) => (
        <motion.div
          className="number-cell"
          key={`${drawId}-${number}`}
          initial={{ opacity: 0, y: 18, rotate: -2 }}
          animate={{ opacity: 1, y: 0, rotate: 0 }}
          transition={{ delay: index * 0.07, duration: 0.28 }}
        >
          <span className="number-index">0{index + 1}</span>
          <strong>{String(number).padStart(2, '0')}</strong>
        </motion.div>
      ))}
    </div>
  );
}

export default NumberGrid;